import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=a2a4dae6"
import script from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=a2a4dae6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports